import {le, today} from "@Common/utils/date-object";

import {parseDate} from "./parse-date";

export const isEnrollable = (edition) => le(today(), parseDate(edition.enrollmentDeadline));

